import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';
import { RouterModule } from '@angular/router';
//import { NgDatepickerModule } from 'ng2-datepicker';
import { HashLocationStrategy, LocationStrategy, APP_BASE_HREF } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { MyDatePickerModule } from 'mydatepicker';
import { AuthGuard } from './AuthGuard/AuthGuard.Component';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';




import { AppComponent } from './app.component';
import { LoginComponent } from './Login/Login.component';
import { HttpModule } from '@angular/http';
import { DashboardComponent } from './Dashboard/DashboardComponent';
import { UserComponent } from './Users/UsersComponent';
import { BreadCrumbs } from './Shared/BreadCrumbs';
import { ManagementFooter } from './Shared/ManagementFooter';
import { ManagementHeader } from './Shared/ManagementHeader';
import { OrganizationSearchComponent } from './Organization/OrganizationSearch.component';
import { OrganizationComponent } from './Organization/Organization.component';
import { EntitySearchComponent } from './Entity/EntitySearch.component';
import { CreateEntityComponent } from './Entity/CreateEntity.component';
import { UserSearchComponent } from './Users/UserSearch.Component';
import { FeatureConfigurationComponent } from './Organization/FeatureConfiguration.Component';
import { SubscriptionDetails } from './Subscription/SubscriptionDetails.component';
import { SubscriptionSearch } from './Subscription/SubscriptionSearch.component';
import { PayrollRevisionDatacomponent } from './Payroll_Revision_Data/PayrollRevisionData.component';
import { ReportDashboardComponent } from './Reports/ReportDashboardComponent';
import { PLReportGroupingComponent } from './Reports/PLReportGroupingComponent';
import { ReportGeneratedComponent } from './Reports/ReportGenerated.component';
import { Role } from './Classes/CommonClass';
import { AutoImportSearchComponent } from './AutoImportStatus/AutoImportSearch.component';
import { WebJobDetailsComponent } from './AutoImportStatus/WebJobDetails.component';
import { PhoneMaskDirective } from './phone-mask.directive';
import { BackupDatabase } from './BackupDatabase/BackupDatabase.component';
import { UserPunchFacesComponent } from './UserPunchFaces/UsersComponent';
import { PDFToExcelComponent } from './PDFToExcelImport/PDFComponent';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ConfirmDialogService } from './confirm-dialog/confirm-dialog.service';
import { SignatoryFormComponent } from './Subscription/Signatory/SignatoryForm.component';
import { LoginService } from './Services/LoginService';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent, DashboardComponent, ManagementHeader, UserComponent, ManagementFooter, BreadCrumbs,
    OrganizationComponent, OrganizationSearchComponent, EntitySearchComponent, UserSearchComponent, CreateEntityComponent,
    FeatureConfigurationComponent, SubscriptionDetails, SubscriptionSearch, PayrollRevisionDatacomponent, ReportDashboardComponent,
    PLReportGroupingComponent, ReportGeneratedComponent, WebJobDetailsComponent, AutoImportSearchComponent, PhoneMaskDirective, BackupDatabase, UserPunchFacesComponent,
    PDFToExcelComponent,
    ConfirmDialogComponent,
    SignatoryFormComponent
  ],
  exports: [
    PhoneMaskDirective,
    ConfirmDialogComponent,

  ]
  ,
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    MyDatePickerModule,
    HttpModule, BrowserAnimationsModule, MatSortModule,
    MatTableModule, MatCheckboxModule,
    HttpClientModule, NguiAutoCompleteModule,
    FormsModule, ToastModule.forRoot(),
    RouterModule.forRoot([
      { path: '', redirectTo: 'Login', pathMatch: 'full' },
      { path: 'Login', component: LoginComponent },
      { path: 'Dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
      { path: 'Users', component: UserComponent, canActivate: [AuthGuard], data: { roles: [Role.Administrator] } },
      { path: 'Organization', component: OrganizationSearchComponent, canActivate: [AuthGuard] },
      { path: 'OrganizationDetails', component: OrganizationComponent, canActivate: [AuthGuard] },
      { path: 'Entity', component: EntitySearchComponent, canActivate: [AuthGuard] },
      { path: 'CreateEntity', component: CreateEntityComponent, canActivate: [AuthGuard] },
      { path: 'IF Users', component: UserSearchComponent, canActivate: [AuthGuard] },
      { path: 'Feature Configurations', component: FeatureConfigurationComponent, canActivate: [AuthGuard] },
      { path: 'SubscriptionDetails', component: SubscriptionDetails, canActivate: [AuthGuard] },
      { path: 'Subscription', component: SubscriptionSearch, canActivate: [AuthGuard] },
      { path: 'Payroll-Revision', component: PayrollRevisionDatacomponent, canActivate: [AuthGuard] },
      { path: 'Reports', component: ReportDashboardComponent, canActivate: [AuthGuard], data: { roles: [Role.Administrator] } },
      { path: 'PLGroupingReports', component: PLReportGroupingComponent, canActivate: [AuthGuard], data: { roles: [Role.Administrator] } },
      { path: 'Report-Generated', component: ReportGeneratedComponent, canActivate: [AuthGuard] },
      { path: 'Service Monitoring Detailed', component: WebJobDetailsComponent, canActivate: [AuthGuard] },
      { path: 'AutoImportSearch', component: AutoImportSearchComponent, canActivate: [AuthGuard] },
      { path: 'Backup Database', component: BackupDatabase, canActivate: [AuthGuard] },
      { path: 'Punch Faces', component: UserPunchFacesComponent, canActivate: [AuthGuard] },
      { path: 'PDF to Excel Converter', component: PDFToExcelComponent, canActivate: [AuthGuard] }
    ])
  ],
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }, AuthGuard,
  { provide: LocationStrategy, useClass: HashLocationStrategy },
    ConfirmDialogService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    , LoginService],
  bootstrap: [AppComponent]

})
export class AppModule { }




// WEBPACK FOOTER //
// ./src/app/app.module.ts